const registrar_entrega_de_relatorio_final_da_escola = [
  {
    path: "/registrar-entrega-de-relatorio-final-da-escola",
    name: "registrar_entrega_de_relatorio_final_da_escola",
    meta: {
      allowedPermissions: ["relatoriofinal_entrega"],
      breadCrumb: "Processo de Resultado Final - Relatório Final Escola",
    },
    component: () =>
      import(
        "@/views/RegistrarEntregaDeRelatorioFinalDaEscola/RegistrarEntregaDeRelatorioFinalDaEscola.vue"
      ),
  },
];

export { registrar_entrega_de_relatorio_final_da_escola };
